export const maskPhoneNumber = (phoneNumber: string) => {
    // Check if phoneNumber is at least 10 digits
    if (phoneNumber && phoneNumber.length >= 10) {
        // Replace first 6 digits with asterisks and keep the last 4 digits
        return '***-***-' + phoneNumber.slice(-4);
    }
    return phoneNumber; // Return original if conditions not met
};
